import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Star, Check, ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import './TracksSection.css';

const TracksSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const sliderRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  let profManSrc = '';
  let discWomanSrc = '';
  try { profManSrc = require('../../assets/img/professional-man.png'); } 
  catch(e) { profManSrc = 'https://ui-avatars.com/api/?name=Professional+Man&background=random'; }
  try { discWomanSrc = require('../../assets/img/discovery-woman.png'); } 
  catch(e) { discWomanSrc = 'https://ui-avatars.com/api/?name=Discovery+Woman&background=random'; }

  const profCard = (
      <div className="track-card prof-card" style={isMobile ? {margin: '0 10px'} : {}}>
        <div className="track-content">
          <div className="track-header">
            <Star className="track-star prof-star" fill="#4f46e5" color="#4f46e5" size={28} />
            <h3 className="track-title">PROFESSIONAL TRACK</h3>
            <span className="track-badge prof-badge">For Career Focused Artists</span>
          </div>
          <p className="track-desc">
            For actors, models, dancers, singers and<br/>
            performers building a career in the industry.
          </p>
          <ul className="track-features prof-features">
            <li><Check size={16} /> Verified casting calls & professional opportunities</li>
            <li><Check size={16} /> AI insights & performance feedback</li>
            <li><Check size={16} /> Track applications & callbacks</li>
            <li><Check size={16} /> Build your portfolio & get discovered</li>
          </ul>
          <div className="track-actions">
            <button className="btn-solid prof-btn">Join as Professional</button>
            <button className="btn-outline">Explore Auditions<ArrowRight size={16} className="d-none d-lg-block ms-1" /></button>
          </div>
        </div>
        <img src={profManSrc} alt="Professional Man" className="track-img prof-img" />
      </div>
    );

    const discCard = (
      <div className="track-card disc-card" style={isMobile ? {margin: '0 10px'} : {}}>
        <div className="track-content">
          <div className="track-header">
            <Star className="track-star disc-star" fill="#f59e0b" color="#f59e0b" size={28} />
            <h3 className="track-title disc-title">DISCOVERY TRACK</h3>
            <span className="track-badge disc-badge">For First-Time Performers</span>
          </div>
          <p className="track-desc">
            For students, working professionals, kids or<br/>
            anyone who wants to explore their talent<br/>
            and have fun.
          </p>
          <ul className="track-features disc-features">
            <li><Check size={16} /> Beginner friendly auditions & challenges</li>
            <li><Check size={16} /> Workshops & learning experiences</li>
            <li><Check size={16} /> Build confidence & stage presence</li>
            <li><Check size={16} /> No commitment. Pay as you go.</li>
          </ul>
          <div className="track-actions">
            <button className="btn-solid disc-btn">Explore as Performer</button>
            <button className="btn-outline">Try Now<ArrowRight size={16} className="d-none d-lg-block ms-1" /></button>
          </div>
        </div>
        <img src={discWomanSrc} alt="Discovery Woman" className="track-img disc-img" />
      </div>
    );

  return (
    <section className="tracks-wrapper">
      {isMobile ? (
        <div style={{ position: 'relative' }}>
          <div className="d-flex justify-content-end mb-3 gap-2" style={{ paddingRight: '15px' }}>
            <button onClick={() => sliderRef.current?.slickPrev()} className="btn-nav-arrow"><ChevronLeft size={20}/></button>
            <button onClick={() => sliderRef.current?.slickNext()} className="btn-nav-arrow"><ChevronRight size={20}/></button>
          </div>
          <Slider ref={sliderRef} arrows={false} infinite={false} slidesToShow={1.15} speed={500} dots={false}>
            <div>{profCard}</div>
            <div>{discCard}</div>
          </Slider>
        </div>
      ) : (
        <div className="tracks-container">
          {profCard}
          {discCard}
        </div>
      )}
    </section>
  );
};

export default TracksSection;
